import React from 'react';

import {useTranslation} from 'react-i18next';

import {TAXPAYER_ROLES} from '@/entities/user/permissions';
import {PermissionAccess} from '@/features/PermissionAccess';
import {PageHeader} from '@/widgets/PageHeader';
import {Period} from '@/widgets/Period';
import {Wrapper} from '@pages/Invoices/styled';
import {InvoicesSummary} from '@pages/Invoices/ui/Summary';
import {InvoicesList} from '@pages/Invoices/ui/Table';
import {Page} from '@shared/ui/Page';

export const InvoicesPage = () => {
    const {t} = useTranslation();

    return (
        <Page>
            <Wrapper>
                <PageHeader title={t('page_invoices.title')}>
                    <Period requireMonth={false} />
                </PageHeader>
                <PermissionAccess roles={TAXPAYER_ROLES}>
                    <InvoicesSummary />
                </PermissionAccess>
                <InvoicesList />
            </Wrapper>
        </Page>
    );
};
